import React, { FC } from 'react';

export const IconBurger: FC<React.PropsWithChildren<{ className?: string }>> = ({ className = '' }) => (
  <svg className={className} width="20" height="13" viewBox="0 0 22 16" fill="none" xmlns="http://www.w3.org/2000/svg">
    <path d="M1 7.6665H21" stroke="#334155" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round" />
    <path d="M1 1H21" stroke="#334155" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round" />
    <path d="M1 14.3335H21" stroke="#334155" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round" />
  </svg>
);
